var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close hec-close",attrs:{"aria-label":_vm.helpText,"title":_vm.helpText},on:{"click":_vm.onClick}},[_c('fa-icon',{attrs:{"icon":"times"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }